import { render, staticRenderFns } from "./AutoReminder.vue?vue&type=template&id=708ef618&"
import script from "./AutoReminder.vue?vue&type=script&lang=js&"
export * from "./AutoReminder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports